<template>
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <div class="comingsoon">
                <div class="comingsoon-inner text-center">
                    <div class="logo-wrraper"><img class="img-fluid" :src="getImages('logo/logo-1.png')" alt="">
                    </div>
                    <h5>WE ARE COMING SOON</h5>
                    <div class="countdown" id="clockdiv">
                        <comingsoonTimer />
                    </div>
                </div>
            </div>
    </div>
    </div>
</template>
<script lang="ts" setup>
import { getImages } from "@/composables/commen/getImages"
import { defineAsyncComponent } from 'vue';
const comingsoonTimer = defineAsyncComponent(() => import("@/components/commen/comingsoonTimer.vue"))
</script>